import { Component, Input, OnInit } from '@angular/core';
import { EmpresaService } from 'src/app/content/empresa/services/empresa.service';
import { GetOfertasTrabajoDetalleResponse } from 'src/app/content/egresado/responses/get-detalles-oferta-egr-response';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { firstValueFrom } from 'rxjs';
import { EgresadoService } from 'src/app/content/egresado/services/egresado.service';
import { DocenteService } from 'src/app/content/docente/services/docente.service';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.css']
})
export class OfferDetailsComponent implements OnInit {
  @BlockUI('projectInfo') blockUIProjectInfo: NgBlockUI;
  @BlockUI('userProfile') blockUIUserProfile: NgBlockUI;
  @Input() offerId : number;
  @Input() tipoUsuario : number = 1; // 1=empresa, 2=egresado, 3=docente

  public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: false,
    reload: false
  };

  idOferta : number;
  detallesOferta : GetOfertasTrabajoDetalleResponse;

  submitted = false;

  constructor(private empresaService : EmpresaService,
              private egresadoService : EgresadoService,
              private docenteService : DocenteService,
              private router : Router,
              private toastr: ToastrService){   
  }

  async ngOnInit() 
  {
    if(!(this.offerId>0))
    {
      this.validateOfferId();
    }
    await this.validateOfferDetails();
    this.breadcrumb = {
      'mainlabel': 'Detalles Oferta'
      };
  }

  validateOfferId()
  {
    if(this.tipoUsuario == 1){
      this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
      this.router.navigate(['empresa/ofertasPublicadas'], {
        queryParams: {},
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    if(this.tipoUsuario == 2){
      this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
      this.router.navigate(['egresado/ofertasPublicadas'], {
        queryParams: {},
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    if(this.tipoUsuario == 3){
      this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
      this.router.navigate(['docente/ofertasPublicadas'], {
        queryParams: {},
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
  }

  async validateOfferDetails()
  {
    if(this.tipoUsuario == 1){
      if(await !this.getOfferDetails(this.offerId)) // obtener id dinámico
      {
        this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
        this.router.navigate(['empresa/ofertasPublicadas'], {
          queryParams: {},
          skipLocationChange: true //skip location para ocultar el json de la URL
        });
      }
    }
    if(this.tipoUsuario == 2){
      if(await !this.getOfferDetailsEgresado(this.offerId)) // obtener id dinámico
      {
        this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
        this.router.navigate(['egresado/ofertasPublicadas'], {
          queryParams: {},
          skipLocationChange: true //skip location para ocultar el json de la URL
        });
      }
    }
    if(this.tipoUsuario == 3){
      if(await !this.getOfferDetailsDocente(this.offerId)) // obtener id dinámico
      {
        this.toastr.error('No fue posible cargar los datos de la oferta.','Error');
        this.router.navigate(['docente/ofertasPublicadas'], {
          queryParams: {},
          skipLocationChange: true //skip location para ocultar el json de la URL
        });
      }
    }
  }

  async getOfferDetails(idOferta:number) : Promise<Boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.empresaService.getDetallesOferta(idOferta));
      if(data)
      {
        this.detallesOferta = data;
        this.toastr.success('Ya puedes revisar los detalles.','Datos Obtenidos');
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async getOfferDetailsDocente(idOferta:number) : Promise<Boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.docenteService.getDetallesOferta(idOferta));
      if(data)
      {
        this.detallesOferta = data;
        this.toastr.success('Ya puedes revisar los detalles.','Datos Obtenidos');
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async getOfferDetailsEgresado(idOferta:number) : Promise<Boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.egresadoService.getDetallesOferta(idOferta));
      if(data)
      {
        this.detallesOferta = data;
        this.toastr.success('Ya puedes revisar los detalles.','Datos Obtenidos');
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  onProjectInfoSubmit() {
    this.submitted = true;

    // if (this.projectInfo.invalid) {
    //   return;
    // }
  }

  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  reloadProjectInfo() {
    this.blockUIProjectInfo.start('Loading..');

    setTimeout(() => {
      this.blockUIProjectInfo.stop();
    }, 2500);
  }
}
